// トースト通知。ストアやエンジンなど Vue コンポーネント外からも呼べる
// (参照プロジェクト useToast.ts と同じ構造)。
import { ref, readonly } from 'vue'

export type ToastLevel = 'info' | 'success' | 'warn' | 'error'

export interface ToastItem {
  id: number
  level: ToastLevel
  message: string
}

const toasts = ref<ToastItem[]>([])
let seq = 0

function push(level: ToastLevel, message: string, duration?: number): number {
  const id = ++seq
  toasts.value.push({ id, level, message })
  const ms = duration ?? (level === 'error' ? 6000 : 3000)
  if (ms > 0) setTimeout(() => dismiss(id), ms)
  return id
}

function dismiss(id: number): void {
  toasts.value = toasts.value.filter(t => t.id !== id)
}

export const toast = {
  info: (m: string, d?: number) => push('info', m, d),
  success: (m: string, d?: number) => push('success', m, d),
  warn: (m: string, d?: number) => push('warn', m, d),
  error: (m: string, d?: number) => push('error', m, d),
  dismiss
}

export function useToast() {
  return { toasts: readonly(toasts), ...toast }
}
